// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"164":"1512b0ea","233":"e2e3ff25","810":"cfea61c8","828":"00433387"}[chunkId] + ".css";
};